import { Routes } from '@angular/router';
import { RestrictionsComponent } from './pages/restrictions/restrictions.component';
import { ArchivedRestrictionsComponent } from './pages/archived-restrictions/archived-restrictions.component';
import { VehiclesComponent } from './pages/vehicles/vehicles.component';
import { VehicleComponent } from './pages/vehicle/vehicle.component';
import { FpcsComponent } from './pages/fpcs/fpcs.component';
import { FpcComponent } from './pages/fpc/fpc.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'vehicles',
        pathMatch: 'full',
      },
      {
        path: 'restrictions',
        component: RestrictionsComponent,
      },
      {
        path: 'archived-restrictions',
        component: ArchivedRestrictionsComponent,
      },
      {
        path: 'vehicles',
        component: VehiclesComponent,
      },
      {
        path: 'vehicles/:name',
        component: VehicleComponent,
      },
      {
        path: 'fpcs',
        component: FpcsComponent,
      },
      {
        path: 'fpcs/:fpcid',
        component: FpcComponent,
      },
    ],
  },
];

